import snukReducer from './snukReducer';

const alarmsConfig = (state, action) => snukReducer(state, action, 'alarmsConfig');

export default alarmsConfig;



// WEBPACK FOOTER //
// ./src/reducers/alarmsConfig.js